export default function Button(theme) {
  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: 600,
          transition: 'all 0.2s ease-in-out',
          '&:hover:not(.Mui-disabled):not(.MuiLoadingButton-loading)': {
            transform: 'scale(1.02)',
          },
        },
        sizeSmall: {
          borderRadius: '16px',
        },
        sizeMedium: {
          borderRadius: '24px',
        },
        sizeLarge: {
          lineHeight: '38px',
          borderRadius: '32px',
          fontSize: '1.25rem',
          padding: '8px 32px',
        },
        contained: {
          '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[200],
          },
        },
        outlined: {
          '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[200],
          },
        },
        text: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
      variants: [
        {
          props: { variant: 'outlined', size: 'large' },
          style: {
            borderWidth: '2px',
            '&:hover': { borderWidth: '2px' },
          },
        },
        {
          props: { variant: 'contained', color: 'primary' },
          style: {
            '&:hover:not(.Mui-disabled):not(.MuiLoadingButton-loading)': {
              backgroundColor: theme.palette.mode === 'dark' ? theme.palette.secondary.lighter : theme.palette.secondary.main,
            },
          },
        },
        {
          props: { variant: 'contained', color: 'secondary' },
          style:
            theme.palette.mode === 'dark'
              ? {
                  '&:hover:not(.Mui-disabled):not(.MuiLoadingButton-loading)': {
                    color: theme.palette.primary.contrastText,
                    backgroundColor: theme.palette.primary.main,
                  },
                }
              : {
                  '&:hover:not(.Mui-disabled):not(.MuiLoadingButton-loading)': {
                    outline: `2px solid ${theme.palette.secondary.main}`,
                    backgroundColor: theme.palette.secondary.contrastText,
                    color: theme.palette.secondary.main,
                  },
                },
        },
      ],
    },
  }
}
